import axios from '@/axios.js'

export default {
  fetchRefreshStocks ({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get('/refreshstocksv4/data')
        .then((response) => {
          axios.get('/stocksvolume/data')
          .then((response) => {
            commit('SET_STOCKS', response.data)
            resolve(response)
          })
          .catch((error) => { reject(error) })
        })
        .catch((error) => { reject(error) })
    })
  }, 
  fetchMaxPopularity ({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get('/stocks/getmaxpopularity')
        .then((response) => {
          commit('SET_POPULARITY', response.data[0].maxpopularity)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  }, 
  fetchStocksv3 ({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get('/stocksv4/data')
        .then((response) => {
          commit('SET_STOCKS', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  }, 
  fetchStocksByPopularity ({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get('/stocksbypopularity/data')
        .then((response) => {
          commit('SET_STOCKS', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    }) 
  }, 
  fetchStocksVolume ({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get('/stocksvolume/data')
        .then((response) => {
          commit('SET_STOCKS', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  }, 
  fetchStockByCategory ({ commit }) {
    return new Promise((resolve, reject) => {
      //axios.get('/stocksbycategory/data')
      axios.get('/getstockhistorybyproductcategory')
        .then((response) => { 
          commit('SET_STOCKBYCATEGORY', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  }, 
  fetchStocks ({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get('/stocksv2/data')
        .then((response) => {
          commit('SET_STOCKS', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  }, 
  fetchStock ({ commit }, productId) {
    return new Promise((resolve, reject) => {
      axios.get(`/stockv2/data/${productId}`)
        .then((response) => {
          commit('SET_STOCK', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    }) 
  },
  fetchStockOperationList ({ commit }, productId) {
    return new Promise((resolve, reject) => {
      axios.get(`/stockoperationlist/data/${productId}`)
        .then((response) => {
          commit('SET_STOCK_OPERATION_LIST', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    }) 
  },
  fetchStockQuotation ({ commit }, productId) {
    return new Promise((resolve, reject) => {
      axios.get(`/stockquotation/data/${productId}`)
        .then((response) => {
          commit('SET_STOCK_QUOTATION', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    }) 
  }
}
 